import { ApiParams, BaseClient, IActionResult } from "../../../assets/utils/lib";
import { CommunityNeighborhoodDto } from "../../dto";

export class CommunityNeighborhoodClient extends BaseClient {
  routes = ["admin", "Community"];

  async getCommunityNeighborhoodsAsync(communityId: string): Promise<CommunityNeighborhoodDto[]> {
    return await this.getAsync<CommunityNeighborhoodDto[]>(
      ["GetCommunityNeighborhoods"],
      [new ApiParams("communityId", communityId, true)],
    );
  }

  async getCommunityNeighborhoodAsync(id: string): Promise<CommunityNeighborhoodDto> {
    return await this.getAsync<CommunityNeighborhoodDto>(
      ["GetCommunityNeighborhood"],
      [new ApiParams("id", id, true)],
    );
  }

  async saveCommunityNeighborhoodAsync(payload: CommunityNeighborhoodDto): Promise<IActionResult<CommunityNeighborhoodDto>> {
    return await this.postAsync<CommunityNeighborhoodDto>(["SaveCommunityNeighborhood"], payload);
  }
}
